import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { History, Home, Package, Phone, Share2Icon, ShoppingBag, Store } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useVendor } from '@/contexts/VendorContext';
import axiosInstance from '@/utils/axiosInstance';
import { useUser } from '@/contexts/UserContext';

export default function BottomNav({ page = 'dashboard' }) {
  const [recentOrders, setRecentOrders] = useState(0);
  const { user } = useUser();

  const renderNavItem = (to, icon, label, isActive, badgeCount = 0) => {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Link
            to={to}
            className={`flex flex-col relative items-center justify-center p-2 transition-colors duration-200 ${
              isActive ? 'text-blue-700' : 'text-gray-500 hover:text-primary'
            }`}
          >
            {icon}
            <span className={`text-xs mt-1 ${isActive ? 'font-semibold' : ''}`}>{label}</span>
            {badgeCount > 0 && (
              <div className="absolute top-0 right-0 h-6 w-6 flex items-center justify-center bg-green-600 text-white text-xs rounded-full">
                {badgeCount}
              </div>
            )}
          </Link>
        </TooltipTrigger>
        <TooltipContent side="top">
          <p>{label}</p>
        </TooltipContent>
      </Tooltip>
    );
  };

  const handleShare = async (e) => {
    e.stopPropagation();

    // Clean and construct the URL
    let url = window.location.href.replace(/\/$/, '');
    let title;
    let text;
    if (user?.userType === 'vendor') {
      url = `https://biglocal.in/login?invite=${user?.contactNo.replace('+91', '')}`;

      title = `${user.shopName || `${user.name}'s Store`} on SubziWale`;
      text = `🛒 Check out fresh produce from ${user.shopName || user.name}!\n💚 Support your local vendor.\n👇 Tap to order now:\n${url}`;
    } else {
      url = `https://biglocal.in/login`;

      title = `Hii I am using BigLocal `;
      text = `Hii I am using BigLocal💚 Support your local vendor.\n👇 Tap to order now:\n${url}`;
    }

    try {
      if (navigator.share) {
        await navigator.share({ title, text });
      } else {
        console.log('Web Share API not supported');
      }
    } catch (err) {
      if (navigator.share) {
        await navigator
          .share({ title, text })
          .catch((error) => console.log('Share failed:', error));
      } else {
        console.log('Web Share API not supported');
      }
    }
  };

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const apiRes = await axiosInstance.get(
          `${import.meta.env.VITE_API_URL}/rest/subziwale/api/v1/orders/vendor?status=Pending&pageNo=0`,
          {
            headers: {
              sessionToken: localStorage.getItem('sessionToken'),
              refreshToken: localStorage.getItem('refreshToken'),
              'X-Vendor-Id': user?.id,
            },
          }
        );

        setRecentOrders(apiRes?.data?.length);
      } catch (error) {}
    };

    if (localStorage.getItem('userRole') === 'vendor' && user) {
      fetchOrder();
    }
  }, [user]);

  return (
    <nav>
      {localStorage.getItem('userRole') === 'user' && (
        <TooltipProvider>
          <nav className="w-full fixed bottom-0 max-w-md mx-auto py-0 px-4 flex items-center justify-around bg-gray-50  border-t border-gray-200 shadow-lg z-20">
            {renderNavItem('/', <Home className="h-5 w-5" />, 'Home', page === 'Home')}
            {/* {renderNavItem('/store', <Store className="h-5 w-5" />, 'Store', page === 'dashboard')} */}
            {renderNavItem(
              '/history',
              <History className="h-5 w-5" />,
              'Orders',
              page === 'history'
            )}
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  onClick={(e) => {
                    handleShare(e);
                  }}
                  className="flex flex-col items-center justify-center p-2 text-gray-500 hover:text-primary transition-colors duration-200"
                >
                  <Share2Icon className="h-5 w-5" />
                  <span className="text-xs mt-1">Share</span>
                </button>
              </TooltipTrigger>
              <TooltipContent side="top">
                <p>Share</p>
              </TooltipContent>
            </Tooltip>
          </nav>
        </TooltipProvider>
      )}
      {localStorage.getItem('userRole') === 'vendor' && (
        <TooltipProvider>
          <nav className="w-full fixed bottom-0 max-w-md mx-auto py-0 px-4 flex items-center justify-around bg-gray-50 border-t border-gray-200 shadow-lg z-20">
            {renderNavItem(
              '/vendor',
              <ShoppingBag className="h-5 w-5" />,
              'Orders',
              page === 'orders',
              recentOrders
            )}
            {renderNavItem(
              '/vendor/store',
              <Store className="h-5 w-5" />,
              'Store',
              page === 'dashboard'
            )}
            {renderNavItem(
              '/vendor/product/pricing',
              <Package className="h-5 w-5" />,
              'Products',
              page === 'pricing'
            )}
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  onClick={(e) => {
                    handleShare(e);
                  }}
                  className="flex flex-col items-center justify-center p-2 text-gray-500 hover:text-primary transition-colors duration-200"
                >
                  <Share2Icon className="h-5 w-5" />
                  <span className="text-xs mt-1">Share</span>
                </button>
              </TooltipTrigger>
              <TooltipContent side="top">
                <p>Share</p>
              </TooltipContent>
            </Tooltip>
          </nav>
        </TooltipProvider>
      )}
    </nav>
  );
}
